import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { Mail, ArrowLeft, Loader2, CheckCircle2 } from 'lucide-react';
import api from '../api/client';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err?.message || "Error enviant el correu.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f8f3f4] to-[#f0e8ea] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="Ho-SYS" className="h-20 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900">Recuperar contrasenya</h1>
          <p className="text-gray-500 text-sm mt-1">T'enviarem un enllaç per restablir-la</p>
        </div>

        <Card className="border-0 shadow-xl">
          <CardContent className="pt-6">
            {sent ? (
              <div className="text-center py-4" data-testid="forgot-password-success">
                <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-4" />
                <h2 className="text-lg font-bold text-gray-900 mb-2">Correu enviat!</h2>
                <p className="text-sm text-gray-500 mb-6">
                  Si el correu <strong>{email}</strong> està registrat, rebràs un enllaç per restablir la contrasenya. Revisa la safata d'entrada i la carpeta de correu brossa.
                </p>
                <Link to="/login">
                  <Button variant="outline" className="gap-2" data-testid="back-to-login-btn">
                    <ArrowLeft className="w-4 h-4" /> Tornar a iniciar sessió
                  </Button>
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label htmlFor="email">Correu electrònic</Label>
                  <div className="relative mt-1">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                    <Input
                      id="email"
                      type="email"
                      placeholder="email@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="pl-10"
                      required
                      data-testid="forgot-email-input"
                    />
                  </div>
                </div>

                {error && (
                  <div className="bg-red-50 border border-red-200 rounded-xl p-3 text-sm text-red-700" data-testid="forgot-error">
                    {error}
                  </div>
                )}

                <Button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#7B2D3F] hover:bg-[#7B2D3F]/90"
                  data-testid="forgot-submit-btn"
                >
                  {loading ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    "Enviar enllaç de recuperació"
                  )}
                </Button>

                <p className="text-center text-sm text-gray-500 mt-4">
                  <Link to="/login" className="text-[#7B2D3F] font-medium hover:underline" data-testid="back-to-login-link">
                    <ArrowLeft className="w-3 h-3 inline mr-1" />
                    Tornar a iniciar sessió
                  </Link>
                </p>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
